import * as Period from 'constants/Period';

const BASKETBALL_PERIOD_MAP = {};
BASKETBALL_PERIOD_MAP[3100] = Period.NOT_STARTED;
BASKETBALL_PERIOD_MAP[3101] = Period.FIRST;
BASKETBALL_PERIOD_MAP[3102] = Period.FIRST_BREAK;
BASKETBALL_PERIOD_MAP[3103] = Period.SECOND;
BASKETBALL_PERIOD_MAP[3104] = Period.SECOND_BREAK;
BASKETBALL_PERIOD_MAP[3105] = Period.THIRD;
BASKETBALL_PERIOD_MAP[3106] = Period.THIRD_BREAK;
BASKETBALL_PERIOD_MAP[3107] = Period.FOURTH;
BASKETBALL_PERIOD_MAP[3108] = Period.FOURTH_BREAK;
BASKETBALL_PERIOD_MAP[3109] = Period.OVERTIME;
BASKETBALL_PERIOD_MAP[3110] = Period.FINISHED;

export default BASKETBALL_PERIOD_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Basketball/PeriodMap.js